<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit" v-if="user.login">{{ $t('goods.myPoint') }}{{ user.point }}</div>

			<div class="point_record" @click="$router.push('/integral/record')">
				{{ $t('积分明细') }}
			</div>

			<div class="record" @click="$router.push('/goods/record')">
				<img src="../img/user/record_b.png">
			</div>
		</div>
		<!-- 轮播图 -->
		<div class="swiper_container">
			<van-swipe  :autoplay="2500" class="swiper-container">
				<van-swipe-item v-for="(item, index) in list" :key="index" @click="$router.push('/goods/detail/' + item.id)"
					v-if="index < 3">
					<img :src="item.img">
				</van-swipe-item>
			</van-swipe>
		</div>
		<div class="item_wrap">
			<div class="item_tips">
				{{ $t('goods.hotGoods') }}
			</div>
	

			<div class="product_list_box">

				<div class="header_title">{{ $t('热门兑换') }}</div>
				<div class="product_list">
					<div class="item_product" v-for="(item, index) in list" :key="index"
						@click="$router.push('/goods/detail/' + item.id)">
						<div class="pro_info">
							<img class="pro_logo" :src="item.img" alt="">
							<div class="detail_box">
								<div class="pro_title">{{ item.title }}<span class="hot_box">Hot</span></div>
								<div class="pro_point">{{ item.point }}{{ $t('goods.point') }}<span class="ydh">{{ $t('已兑换')
								}} {{ item.exchange_total }} {{ $t('次') }}</span></div>
							</div>
						</div>
						<!-- 兑换 -->
						<div class="duihuan_box">
							<div class="duihuan_btn">
								{{ $t('兑换') }}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../img/index/qiandao.png">
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import {
	Swipe,
	SwipeItem,
	List
} from 'vant';
Vue.use(Swipe).use(SwipeItem).use(List);
export default {
	name: "goods",
	components: {
		bsHeader
	},
	data() {
		return {
			data: [],
			empty: false,
			loading: false,
			finished: false,
			list: [],
			page: 1,
			listRows: 10,
			user: {
				login: false,
				point: 0,
			},
			signinStatue: false,
			show_kefu: false,
		};
	},
	// //创建前设置
	// beforeCreate() {
	// 	//解决List上拉加载bug
	// 	document.querySelector('body').style["overflow-y"] = "unset";
	// },
	// //销毁前清除
	// beforeDestroy() {
	// 	document.querySelector('body').style["overflow-y"] = "scroll";
	// },
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('user', false);
		this.start();
	},
	mounted() {
		var that = this;
		document.body.addEventListener(
			"scroll",
			function () {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			},
			false
		);
		document.addEventListener(
			"click",
			function (ev) {
				if (ev.target.className != "kefu_img") {
					that.show_kefu = false;
				}
			},
			false
		);

	},
	methods: {
		start() {
			// Fetch('/user/signin').then((r) => {
			// 		this.$toast(this.$t('user.signinSuccess'));
			// 	});
			var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			Fetch('/user/info', {
				isapp: isapp
			}).then((r) => {

				this.signinStatue = r.data.signin;
				this.tax = r.data.tax;
				if (this.signinStatue) {
					this.$toast(this.$t('user.signined'));
					return false;
				}
				this.signinStatue = true;
				Fetch('/user/signin').then((r) => {
					this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
				});
			});

			Fetch('/index/goods_list', {
				page: 1,
				listRows: 10000
			}).then(r => {
				this.user = r.data.user;
				var list = r.data.list;
				for (var i = 0; i < list.length; i++) {
					this.list.push(list[i]);
				}

			});

		},
		kefu_to() {
			if (this.show_kefu) {
				this.start();
			}
			this.show_kefu = !this.show_kefu;
		},
		precision(money) {
			var precision = localStorage.getItem('precision_basic');
			return (money / 1).toFixed(precision);
		},
		
		
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	position: relative;
}
.product_list_box {
	padding: 20px 16px;
	background-color: #FFFFFF;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
	display: flex;
	flex-direction: column;

	.header_title {
		font-size: 15px;
		color: black;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_list {
		.item_product {
			display: flex;
			justify-content: space-between;
			padding: 20px 0;
			border-bottom: 1px solid rgba(185, 174, 174, 0.3);

			.pro_info {
				display: flex;
				justify-content: left;



				.pro_logo {
					width: 80px;
					height: 80px;
				}

				.detail_box {
					display: flex;
					flex-direction: column;
					margin-left: 10px;
					flex: 1;

					.pro_title {
						font-size: 14px;
						line-height: 20px;
						color: black;
						font-weight: 500;

						.hot_box {
							padding: 1px 6px;
							border: 1px solid red;
							border-radius: 25px;
							font-size: 10px;
							color: red;
							margin-left: 5px;

						}
					}

					.pro_point {
						font-size: 14px;
						color: #FFA500;
						font-weight: 500;
						margin-top: auto;

						.ydh {
							font-size: 12px;
							margin-left: 5px;
							color: #817d78;
						}
					}


				}
			}

			.duihuan_box {
				min-width: 120px;
				display: flex;
				align-items: center;
				justify-content: right;

				.duihuan_btn {
					padding: 5px 16px;
					border-radius: 50px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: rgba(173, 216, 230, 0.5);
					color: #0F6EFF;
					font-size: 13px;
					display: inline-block;
				}

			}
		}
	}
}

.red_top_bg {
	position: fixed;
	background: #FFFFFF;
	z-index: 10;

	.point_record {
		position: absolute;
		top: 13px;
		right: 55px;
		font-size: 14px;
	}

	.record {
		position: absolute;
		top: 11px;
		right: 15px;

		img {
			width: 22px;
			height: 22px;
		}
	}
}

.swiper_container {
	// min-height: 182px;
	position: relative;
	background: #FFFFFF;
}

.swiper-container {
	width: 100%;
	margin: 54px 0 0 0;


	.van-swipe-item {
		overflow: hidden;
	}

	img {
		border-radius: 5px;
		margin-left: 3%;
		height: 100%;
		width: 94%;
	}
}

.item_wrap {
	width: 100%;
	margin-top: 15px;

	.item_tips {
		margin-bottom: 10px;
		margin-left: 3%;
		border-left: 5px solid #0F6EFF;
		padding-left: 10px;
		font-size: 14px;
		font-weight: bold;
	}

	.item_list {
		margin-top: 10px;

		.item {
			background: #FFFFFF;
			margin-bottom: 10px;
			width: 45.5%;
			float: left;
			margin-left: 3%;

			.img {

				img {
					width: 100%;
				}
			}

			.title {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 15px 10px;
			}

			.point_wrap {
				padding: 0 10px 10px 10px;

				.point {
					font-size: 18px;
					font-weight: bold;
					color: #0F6EFF;
				}

				.point_tips {
					margin-left: 5px;
				}
			}
		}

	}
}
</style>
